import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { FlcBaseLayer } from "../flc-base-layer.model";

@Injectable()
export class BaseLayerService {

  private baseLayers: FlcBaseLayer[] = [];
  baseLayersFilled = new Subject<FlcBaseLayer[]>();

  public setBaseLayer = new Subject<FlcBaseLayer>();
  public setSelectedBaseLayer = new Subject<FlcBaseLayer>();

  constructor(){
  }

  findByProfileId() {
    this.handleBaseLayers([]);
  }

  private handleBaseLayers(data: FlcBaseLayer[]) {
    let i = 0;
    this.baseLayers.splice(0, this.baseLayers.length);
    this.baseLayers.push(new FlcBaseLayer("NONE", 0, 0));
    this.baseLayers.push(new FlcBaseLayer("OSM", 10, 16));

    this.baseLayersFilled.next(this.baseLayers.slice());
  }

  public setPreSelectedBaseLayer(baselayer: FlcBaseLayer){
      this.setBaseLayer.next(baselayer);
      this.setBaseLayerSelected(baselayer);
  }

  setBaseLayerSelected(baselayer: FlcBaseLayer) {
    this.setSelectedBaseLayer.next(baselayer);
  }
}
